// extracted by mini-css-extract-plugin
module.exports = {"box":"highlight-box_box__d9M5K","inner":"highlight-box_inner__BNcEv"};